import React, { useState } from 'react';

const SidebarDDJobtypes = ({ title, options = [], selectedOptions = [], setSelectedOptions = () => { } }) => {
    const [isOpen, setIsOpen] = useState(true);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleCheckboxChange = (value) => {
        const updated = selectedOptions.includes(value)
            ? selectedOptions.filter(v => v !== value)
            : [...selectedOptions, value];
        setSelectedOptions(updated);
    };

    return (
        <div className="w-full bg-[#18274B05] text-[#5A6474]">
            {/* Header */}
            <button
                className="w-full flex justify-between items-center py-2 px-3 h-10 rounded hover:bg-gray-100 transition text-sm font-dmsans font-bold"
                onClick={toggleDropdown}
            >
                <span className="truncate">{title}</span>
                <svg
                    className={`w-4 h-4 transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {/* Options */}
            {isOpen && (
                <div className="w-full mt-1 space-y-1 px-3">
                    {options.map((option) => (
                        <label
                            key={option.value}
                            className="flex items-center py-2 gap-2 text-sm w-full cursor-pointer"
                        >
                            <input
                                type="checkbox"
                                checked={selectedOptions.includes(option.value)}
                                onChange={() => handleCheckboxChange(option.value)}
                                className="accent-blue-600"
                            />
                            <span className="text-[#5A6474] font-dmsans font-normal break-words">
                                {option.label}
                            </span>
                        </label>
                    ))}
                </div>
            )}
        </div>
    );
};

export default SidebarDDJobtypes;
